export enum TesseractLanguage {
  english = 'eng',
  french = 'fra',
  chineseSimplified = 'chi_sim',
  chineseTraditional = 'chi_tra'
}
